import { useWeb3State } from "@/web3/context";
import { Contract } from "ethers";
import { useCallback, useMemo } from "react";

export default function useUncheckedContractProxy(contract: Contract | null) {
  const { signer } = useWeb3State();

  const uncheckedTxProxy = useCallback(
    (target: Contract, prop: string) => {
      return async (...args: any[]) => {
        const populatedTx = await target[prop].populateTransaction(...args);

        const hash = await signer!.sendUncheckedTransaction(populatedTx);

        return { hash };
      };
    },
    [signer],
  );

  return useMemo(() => {
    if (!contract) return null;
    return new Proxy(contract, {
      get(target, prop, receiver) {
        const propStr = prop as string;

        if (typeof target[propStr] !== "function") {
          return Reflect.get(target, prop, receiver);
        }

        return uncheckedTxProxy(target, propStr);
      },
    });
  }, [contract, uncheckedTxProxy]);
}
